/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * ---------------------------------------------------------------------------------------------
 */

import JSZip from "jszip";

export default async function downloadFile(filename: string, content: string) {
  const blob = await stringToBlob(content);
  linkBlob(blob, filename);
}

export async function stringToBlob(content: string) {
  const zip = new JSZip();
  await zip.loadAsync(content, { base64: true });
  return zip.generateAsync({ type: "blob" });
}

export function linkBlob(blob: Blob, filename: string) {
  const element = document.createElement("a");
  element.setAttribute("href", URL.createObjectURL(blob));
  element.setAttribute("download", filename.replaceAll(".", "_"));
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

